export enum ROLE {
  ADMIN = 'admin',
  MEMBER = 'member',
  GUEST = 'guest',
  SECRETARY = 'secretary',
  FUNCTIONARY = 'functionary',
  EDITOR = 'editor',
  USER = 'user',
  MEMBER_LIGHT = 'member_light',
  MEMBER_LIGHT_ADMIN = 'member_light_admin',
}
